import VueYoutube from 'vue-youtube'

export default ({ app, router, Vue }) => {
  Vue.use(VueYoutube)
}
